var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightSideArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50025 9.99976C1.24425 9.99976 0.98825 9.90176 0.79325 9.70676C0.40225 9.31576 0.40225 8.68376 0.79325 8.29276L4.09825 4.98776L0.91825 1.69476C0.53525 1.29676 0.54625 0.663761 0.94325 0.280761C1.34125 -0.102239 1.97425 -0.0912393 2.35725 0.304761L6.21925 4.30476C6.59825 4.69776 6.59325 5.32076 6.20725 5.70676L2.20725 9.70676C2.01225 9.90176 1.75625 9.99976 1.50025 9.99976Z",
    fill: "#100F15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSideArrow);
export default __webpack_public_path__ + "static/media/RightSideArrow.8d678a86b3211acb3acb2c7278d559e1.svg";
export { ForwardRef as ReactComponent };